
/**
 *      Data-driven UI logic for updating URL and setting global parameters from the URL.
 *
 *      @author Irina Patrikeeva <irina.i.ipatrikeeva@nasa.gov>
 *
 *      Created on 09/13/2017
 *      Modified on 8/16/2021 by Nhi Cmerek
 */

/**
 * Append current search query to the base url
 * When trigger is true, the redirect function is called
 * @param baseURL {string} - base page URL ("search", "view", etc.)
 * @param query {string} - search query
 * @param trigger {boolean} - flag to trigger the redirect
 */
function updateURL( baseURL, query, trigger ) {

    var route = getRouteFromVariables( baseURL, query, App.globalState.currentFilters );

    // Force the router to reload the current page in case the route was the same
    // as in the case when switching from multi-faceted to single type search interface
    var ret = Backbone.history.navigate( route, true );
    if ( ret === undefined ) {
        Backbone.history.loadUrl( route );
    } else {
        router.navigate( route, { trigger: trigger } );
    }
}

/**
 *  Update the end of the URL
 *  @param to {string} - part of URL to update to
 *  @param from {string} - part of URL to update from
 *  @param trigger {boolean} - flag to trigger router navigation
 */
function updateEndURL( to, from, trigger ) {

    var route,
        n;

    route = Backbone.history.getFragment();

    n = route.lastIndexOf( from );

    route = route.slice( 0, n ) + route.slice( n ).replace( from, to );

    var table_bool = false;     // =====
    // console.log('original route: ', route);
    // removes tableview parameter
    if ( route.includes("?tableview=") ) {
        var tmp = route.split('?tableview='); 
        var route = tmp[0];

        if ( tmp[1].includes("&") ) {
            var route = tmp[0] + "?" + tmp[1].split( tmp[1].split( "&", 1 ) + "&")[1];
        };
        // console.log('route ?: ', route);
        var table_bool = true;
    };
    if ( route.includes("&tableview=") ) {
        var tmp = route.split('&tableview='); 
        var route = tmp[0];

        if ( tmp[1].includes("&") ) {
            var route = tmp[0] + tmp[1].split( tmp[1].split( "&", 1 ) )[1];
        };
        // console.log('route &: ', route);
        var table_bool = true;
    };

    if ( table_bool ) {
        window.location.href = "/" + route;
    };

    router.navigate( route, { trigger: trigger } );
}

/**
 * Get a URL to route to based on a query and input collection of filters.
 * @param baseURL {string} The root page URL e.g. search, hst, advanced-search.
 * @param query {string} The current user query.
 * @param collection {Backbone.Collection} Collection of filters.
 * @returns {string}
 */
function getRouteFromVariables( baseURL, query, collection ) {
    var route = baseURL,
        args = {},
        group,
        types;


    if ( query ) {
        route += "?q=" + encodeURIComponent( modifyQuery( query ) );
    }

    // Add type and filters parameters
    if ( collection && collection.length > 0 ) {
        args = getFiltersString( args, collection );
    }

    // Add group parameter
    if ( ! ( App.globalState.filterGroups === '' || App.globalState.filterGroups === 'selectAll' || App.globalState.filterGroups === '#selectAll' ) ) {
        if ( App.globalState.TypeGroups && App.globalState.TypeGroups[ App.globalState.filterGroups ] ) {
            // Get type names from group data structure
            types = App.globalState.TypeGroups[ App.globalState.filterGroups ].split(',');

            // If there's only one data type in a group, add it to type parameter
            if ( types.length === 1 ) {
                args.type = encodeURIComponent( types );
                encodeURIComponent( types[ 0 ] );
            }
        }
        args.group = App.globalState.filterGroups;
    }
    else {
        // check URL
        group = getGroupNameFromURL();
        if ( group ) {
            args.group = group;
        }
    }

    // Add pagesize parameter
    var pagesize = getPageSizeFromURL( Backbone.history.getFragment() );
    if ( pagesize ) {
        args.pagesize = pagesize;
    }

    // Add page parameter
    var page = getPageStringFromURL( Backbone.history.getFragment() );
    if ( page ) {
        args.page = page;
    }

    // Add grid parameter
    var grid = getViewTypeFromURL( Backbone.history.getFragment() );
    if ( grid ) {
        args.view = "grid";
    }

    if ( query ) {
        if ( Object.keys( args ).length > 0 ) {
            route += '&';
        }
        route += _.map( args, function ( value, key ) {
            if ( value && key ) {
                return key + '=' + value;
            }
        }).join('&');

    }

    return route;
}

/**
 * Set global query parameter.
 * @returns {string}
 */
function setQueryFromURL( ) {
    var q = getQueryFromURL( Backbone.history.getFragment() );
    if ( q ) {
        App.globalState.query = cleanInput( q );

    } else {
        // Default global query is "all"
        App.globalState.query = "all";
    }
}

function setAliasFromURL( ){
    var alias = getAliasStringFromURL( Backbone.history.getFragment() );
    alias = cleanInput( alias );

    if ( alias ) {
        App.globalState.alias = alias;
    }
    //console.log("setAliasFromURL: " + App.globalState.alias )
}
/**
 * Get query value from the current URL.
 * @param url {string} URL to parse.
 * @returns {*}
 */
function getQueryFromURL( url ) {
    var q,
        query,
        queryFilters,
        queryArray,
        queryParams;

    if ( url ) {
        queryFilters = url.split('?');
        if ( queryFilters.length > 1 ) {
            queryArray = queryFilters[ 1 ].split('&');
            if ( queryArray && queryArray.length > 0 ) {
                query = queryArray[ 0 ];

                if ( query ) {
                    queryParams = query.split('q=');
                    if ( queryParams && queryParams.length === 2 ) {
                        q = queryParams[ 1 ];
                        q = cleanInput( q );
                    }
                }
            }
        }
    }

    return q;
}

/**
 * Set global search type parameter.
 */
function setTypeFromURL() {
    var type = getTypeStringFromURL( Backbone.history.getFragment() );
    type = cleanInput( type );

    if ( type ) {
        App.globalState.searchType = type;
    } else {
        App.globalState.searchType = null;
    }
}

/**
 * Get data type name from the current Search URL ?q=:query[&type=:type][&filters=:filters].
 * @returns {*}
 */
function getTypeStringFromURL( url ) {
    var result,
        urlArray,
        typeString,
        typeParams;

    if ( url ) {
        urlArray = url.split( '&type=' );
        if ( urlArray && urlArray.length === 2 ) {
            // type found in the URL
            typeString = urlArray[ 1 ];
            if ( typeString ) {
                typeParams = typeString.split('&');
                if ( typeParams && typeParams.length > 0 ) {
                    result = typeParams[ 0 ];
                    result = cleanInput( result );
                }
            }
        }
    }
    return result;
}

/**
 * @param url
 * @returns {string}
 */
function getAliasStringFromURL( url ) {
    var result,
        urlArray,
        AliasString,
        AliasParams;

    if ( url ) {
        urlArray = url.split( '&alias=' );
        if ( urlArray && urlArray.length === 2 ) {
            // type found in the URL
            AliasString = urlArray[ 1 ];
            if ( AliasString ) {
                AliasParams = AliasString.split('&');
                if ( AliasParams && AliasParams.length > 0 ) {
                    result = AliasParams[ 0 ];
                    result = cleanInput( result );
                }
            }
        }
    }
    return result;
}

/**
 * Set global search filters parameter.
 */
function setFiltersFromURL() {
    var filters = getFiltersStringFromURL( Backbone.history.getFragment() );
    if ( filters ) {

        var filters = filters.replace(' &amp; ', ' & ');

        App.globalState.searchFilters = filters;
    } else {
        App.globalState.searchFilters = null;
    }
}

/**
 * Get filters string from the current URL.
 * @returns {*}
 */
function getFiltersStringFromURL( url ) {
    var result,
        urlArray,
        filtersString,
        typeParams;

    if ( url ) {
        urlArray = url.split( '&filters=' );
        if ( urlArray && urlArray.length === 2 ) {
            // filters found in the URL
            filtersString = urlArray[ 1 ];
            if ( filtersString ) {
                // Remove strings that may come after filters like group
                typeParams = filtersString.split('&');
                if ( typeParams && typeParams.length > 0 ) {
                    result = typeParams[ 0 ];
                    result = cleanInput( result );
                }
            }
        }
    }
    return result;
}

/**
 * Set global search page number parameter.
 */
function setPageFromURL() {
    var page = getPageStringFromURL( Backbone.history.getFragment() );
    if ( page ) {
        App.globalState.searchPage = page;
    } else {
        App.globalState.searchPage = 1; // Default page number
    }
}

/**
 * Get page string from the current URL.
 * @returns {*}
 */
function getPageStringFromURL( url ) {
    var result,
        urlArray,
        pageString,
        otherParams;

    if ( url ) {
        urlArray = url.split( '&page=' );
        if ( urlArray && urlArray.length === 2 ) {
            // page found in the URL
            pageString = urlArray[ 1 ];
            if ( pageString ) {
                // Remove strings that may come after page
                otherParams = pageString.split('&');
                if ( otherParams && otherParams.length > 0 ) {
                    result = otherParams[ 0 ];
                    result = cleanInput( result );
                }
            }
        }
    }
    return result;
}

/**
 * Get page size value from the current URL
 * @returns {*}
 */
function getPageSizeFromURL( url ) {
    var result,
        urlArray,
        urlString,
        sizeParams;

    if ( url ) {
        urlArray = url.split( '&pagesize=' );
        if ( urlArray && urlArray.length === 2 ) {
            // size parameter is found in the URL
            urlString = urlArray[ 1 ];
            if ( urlString ) {
                // Remove strings that may come after size like filters or group
                sizeParams = urlString.split('&');
                if ( sizeParams && sizeParams.length > 0 ) {
                    result = sizeParams[ 0 ];
                    result = cleanInput( result );
                }
            }
        }
    }
    return result;
}

/**
 * Set global pageSize parameter from URL
 */
function setPageSizeFromURL() {
    var size = getPageSizeFromURL( Backbone.history.getFragment() );
    if ( size ) {
        App.globalState.pageSize = size;
    } else {
        App.globalState.pageSize = 20; // default number of records per page
    }
}

/**
 * Set global group parameter.
 */
function setGroupFromURL() {
    var group = getGroupFromURL();
    if ( group ) {
        App.globalState.group = group;
    } else {
        App.globalState.group = "allgroup"; // Default group is "allgroup"
    }
}

/**
 * Get group value from the current URL.
 * @returns {*}
 */
function getGroupFromURL() {

    var group;

    var current = Backbone.history.getFragment();
    if ( current ) {
        var url = current.split('group=');

        if ( url && url.length === 2 ) {
            // group parameter is found in the URL
            var urlString = url[ 1 ];
            if ( urlString ) {
                // Remove strings that may come after like filters, pagesize, etc.
                var urlArray = urlString.split('&');
                if ( urlArray && urlArray.length > 0 ) {
                    group = urlArray[ 0 ];
                    group = cleanInput( group );
                }
            }
        }
    }

    return group;
}

/**
 * Set global search results view type parameter.
 */
function setViewTypeFromURL( ) {
    if ( Backbone && Backbone.history ) {
        var view = getViewTypeFromURL( Backbone.history.getFragment() );
        if ( view && view === "grid" ) {
            App.globalState.grid = true;
        } else {
            App.globalState.grid = false; // Default view
        }
    }
}

/**
 * Get search results view type value from the current URL.
 * @returns {*}
 */
function getViewTypeFromURL( inputurl ) {
    var searchViewType;
    if ( inputurl ) {
        var url = inputurl.split('view=');
        if ( url && url.length === 2 ) {
            // parameter is found in the URL
            var urlString = url[ 1 ];
            if ( urlString ) {
                // Remove strings that may come after like filters, pagesize, etc.
                var urlArray = urlString.split('&');
                if ( urlArray && urlArray.length > 0 ) {
                    searchViewType = urlArray[ 0 ];
                    searchViewType = cleanInput( searchViewType );
                }
            }
        }
    }
    return searchViewType;
}

/**
 * Set global nosearch parameter.
 */
function setNoSearchFlagFromURL() {
    var nosearch = getNoSearchFlagFromURL();
    if ( nosearch ) {
        App.globalState.nosearch = nosearch;
    } else {
        App.globalState.nosearch = "false"; // Default nosearch flag is "false"
    }
}

/**
 * Get group value from the current URL.
 * @returns {*}
 */
function getNoSearchFlagFromURL() {

    var nosearch;

    var current = Backbone.history.getFragment();
    if (current) {
        var url = current.split('nosearch=');

        if ( url && url.length === 2 ) {
            // nosearch parameter is found in the URL
            var urlString = url[ 1 ];
            if ( urlString ) {
                // Remove strings that may come after like filters, pagesize, etc.
                var urlArray = urlString.split('&');
                if ( urlArray && urlArray.length > 0 ) {
                    nosearch = urlArray[ 0 ];
                    nosearch = cleanInput( nosearch );
                }
            }
        }
    }

    return nosearch;
}

/**
 * Clean XSS vulnerable inputs such as scripts and JavaScript that the browser can execute.
 * @param s {string} Input to clean.
 * @returns {string} XSS-safe input string.
 */
function cleanInput( s ) {

    if ( s ) {

        var orig_s = s;

        s = s.toString();

        // Remove script tags
        // var scriptRegEx = /script/;
    	var regEx = /[^a-zA-Z]*script[^a-zA-Z]/;
        var scriptRegEx = new RegExp(regEx, "ig");
        s = s.replace( scriptRegEx, "" );

        // Remove all quotes
        var quotesRegEx = /['"]+/g;
        s = s.replace( quotesRegEx, '' );

        // Remove special characters
        s = modifyQuery( s );

        // Remove special HTML
        s = sanitizeAll( s );

        // re-runs cleaning until there's no more to clean
        while ( orig_s !== s ) {

            var orig_s = s;

            s = s.toString();

            // Remove script tags
            var regEx = /[^a-zA-Z]*script[^a-zA-Z]/;
            var scriptRegEx = new RegExp(regEx, "ig");
            s = s.replace( scriptRegEx, "" );
    
            // Remove all quotes
            var quotesRegEx = /['"]+/g;
            s = s.replace( quotesRegEx, '' );
    
            // Remove special characters
            s = modifyQuery( s );
    
            // Remove special HTML
            s = sanitizeAll( s );
        };
    };
    return s;
};

/**
 * Get base URL route without optional parameters: : {base URL}?{optional parameters}.
 * @returns {*} Base URL route.
 */
function getURLBaseRoute( input ) {

    var route;

    if ( input && typeof input === "string" ) {
        var urls = input.split( '?' );
        if ( urls && urls.length > 0 ) {
            route = urls[ 0 ];
        }
    }
    return route;

}

/**
 * Get URL optional string parameters: {base URL}?{optional parameters}
 * @param input {string} Input string.
 * @returns {*} URL string of optional parameters.
 */
function getURLParameters( input ) {

    var params;

    if ( input && typeof input === "string" ) {
        var urls = input.split('?');
        if (urls && urls.length > 1) {
            params = urls[1];
        }
    }

    return params;
}

/**
 * Get API call URL for ad-hoc field aggregations.
 * @param dataModelName {string} Data model type (name).
 * @param field {object} Field data object.
 * @param aggType {string} Aggregation type such as count.
 * @param aggSort {string} Aggregation field to sort the results on.
 * @param order {string} Aggregation sorting order.
 * @returns {string}
 */
function getFieldAggregationURL( dataModelName, field, aggType, aggSort, order ) {
    var url = '';

    if ( dataModelName && field && aggType ) {

        var fieldName = field.name;
        var fieldType = field.type;

        if ( fieldName ) {
            url = '/explore/api/v1/query?aggs=' + dataModelName + '|' + fieldName;

            // Check if field model has a default_delimiter attribute
            // If field has a non-empty "default_delimiter" attribute, add delimiter value after the field name.

            var fieldDelimiter = field.default_delimiter;
            if ( fieldDelimiter ) {
                url += '.' + fieldDelimiter;
            } else if ( fieldType === "string" || fieldType === "text" ) {
                // If field does not have a non-empty "default_delimiter" attribute, check field type.
                // If field is of type "string" or "text", add .keyword after the field name.
                url += '.keyword';
            }

            url += '|' + aggType;
            url += '&type=' + dataModelName;
            if ( aggSort ) {
                url += '&aggSort=' + aggSort;
            }
            if ( order ) {
                url += '&order=' + order;
            }
        }
    }

    return url;
}
